module.exports = __webpack_public_path__ + "img/article_ad_banner_02.f439fddf.jpg";